"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var errorColor = 'red';

var makeStyle = function makeStyle() {
  return {
    FormBase: {
      '&.disabled': {
        '& .form-group .control-label': {
          color: '#999'
        }
      },
      '& .form-horizontal': {
        margin: 0,
        '& .stilo-input-horizontal': {
          display: 'flex',
          alignItems: 'center',
          '& .stilo-input': {
            flex: '1',
            '-ms-flex-preferred-size': 'auto'
          }
        },
        '& .control-label.label-left': {
          textAlign: 'left'
        },
        '& .control-label.optional': {
          color: '#bbb'
        },
        '& .checkbox': {
          paddingLeft: 0
        },
        '& .form-group': {
          'font-weight': 'normal',
          marginBottom: '0',
          marginTop: '15px',
          '&.fluid-container': {
            marginRight: 0
          },
          '& .control-label': {
            'font-weight': 'normal',
            '&.title': {
              fontWeight: '600',
              marginTop: '15px'
            }
          },
          '&.has-error': {
            '& .form-control': {
              border: '1px ' + errorColor + ' solid'
            },
            '& .control-label': {
              color: errorColor
            },
            '& .error': {
              '& span': {
                color: errorColor
              }
            },
            '& .help-block': {
              color: errorColor
            }
          }
        },
        '& label': {
          '&.title': {
            width: '100%'
          }
        },
        '& .stilo-input-icon': {
          cursor: 'pointer',
          paddingLeft: 4,
          '& .icon-container': {
            display: 'flex',
            alignItems: 'center'
          }
        },
        '& .btn-group': {
          width: '100%',
          display: 'flex',
          '& .btn': {
            flex: 1
          }
        },
        '& .btn:focus': {
          outline: 'none!important'
        },
        '& .form-control, & .rc-select-selection': {
          boxShadow: 'none',
          outline: 'none',
          appearance: 'none',
          borderRadius: 4,
          '&:focus': {
            boxShadow: 'none'
          }
        },
        '& .dropdown': {
          marginBottom: '0'
        },
        '& .form-control[disabled], .form-control[readonly], fieldset[disabled] .form-control': {
          'backgroundColor': '#fff',
          'color': '#9c9c9c'
        },
        '& .help-block': {
          marginBottom: 0
        },
        '& .spacer': {
          '&:after': {
            content: '\'\\00a0\''
          }
        },
        '& .row': {
          '&>div': {
            paddingLeft: 5,
            paddingRight: 5
          },
          '& .cell-3': {
            paddingLeft: 0,
            display: 'flex',
            alignItems: 'center'
          }
        },
        '& .optional': {
          fontStyle: 'italic',
          padding: '0 0 0 7px',
          lineHeight: '31px',
          color: '#8a8a8a'
        }
      }
    }
  };
};

var _default = makeStyle;
exports["default"] = _default;
//# sourceMappingURL=style.js.map